import { QueryClient } from '@tanstack/react-query';

import { SESSION_EXPIRED_ERROR } from '@/assets/AppConstants';

/**
 * The app's single QueryClient, kept OUTSIDE the React tree on purpose: plain service modules
 * (`src/services/*`) import it to read and write the very same cache the components use through
 * `QueryClientProvider`. That is what lets the legacy promise-returning helpers share React Query's
 * cache and its in-flight dedupe without rewriting their 28 call sites.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      gcTime: 10000,
    },
    queries: {
      gcTime: 30000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error: Error & { status?: number }) => {
        if (error.status === SESSION_EXPIRED_ERROR) return false;
        if (error.status === 500) return false;
        return failureCount < 3;
      },
    },
  },
});

export default queryClient;
